<div class="container">
  <div *ngIf="invoices && !invoices.results.length">
    No Invoices.
  </div>
  <!-- <div class="d-flex justify-content-end mb-3">
    <button class="custom-button" (click)="onAddInvoice()">New Invoice</button>
  </div> -->

  <div *ngIf="invoices && invoices.results.length" class="d-flex justify-content-between align-items-end mb-3">
    <div style="padding-left: 3.5px;">
      <select class="form-control select-custom" name="" id="" [(ngModel)]="perPage" (change)="changePerPage($event)">
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="30">30</option>
      </select>
    </div>
    <p class="number-vehicles">{{ lower }}-{{ upper }} <span style="font-weight: 100;" translate>vehicles.of</span>
      {{ invoices.count }} <span style="font-weight: 100; text-transform: lowercase;" translate>invoice.invoices</span></p>
  </div>

  <div *ngIf="invoices && invoices.results.length" class="row">
    <div class="d-flex col-xl-3-custom col-lg-4 col-md-6 col-sm-12" *ngFor="let invoice of invoices.results">
      <div class="card p-3">
        <div class="three_dots">
          <div class="dropdown">
            <button class="btn" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              <i class="fa fa-ellipsis-v"></i>
            </button>

            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" style="cursor: pointer;" [routerLink]="[invoice.id]" translate>invoice.details</a>
              <a *ngIf="!['client'].includes(currentUser.role.name) && ['prepaid'].includes(invoice.type) && !invoice.closed" (click)="onPay(invoice)" class="dropdown-item" style="cursor: pointer;" translate>invoice.close</a>
              <a *ngIf="currentUser.role.name !== 'client' && invoice.type === 'postpaid' && !invoice.closed" (click)="onPay(invoice)" class="dropdown-item" style="cursor: pointer;" translate>invoice.pay</a>
            </div>
          </div>
        </div>
        <div>
          <span class="invoice_number" translate [translateParams]="{number: invoice.number}">invoice.invoiceNumber</span>
          <p class="small">{{invoice.createdAt | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
        </div>

        <div class="my-3">
          <div *ngIf="['info','prepaid'].includes(invoice.type)" style="position: relative;">
            <div *ngIf="invoice.closed">
              <span class="badge badge-pill badge-success px-2 py-1 mr-2" translate>invoice.closed</span>
              <span class="small">{{invoice.closedAt | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
            </div>
            <span style="font-size: .87rem;" class="badge badge-pill badge-light px-2 py-1" *ngIf="!invoice.closed" translate>invoice.opened</span>
          </div>
          <div *ngIf="invoice.type === 'postpaid'" style="position: relative;">
            <div *ngIf="invoice.closed">
              <span class="badge badge-pill badge-success px-3 py-2 mr-2" translate><i class="fa fa-dollar-sign mr-2"></i>invoice.paid</span>
              <span class="small">{{invoice.closedAt | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
            </div>

            <div *ngIf="!invoice.closed && +invoice.paidAmount === 0">
              <span style="font-size: .87rem;" class="badge badge-pill badge-light px-3 py-2" translate>invoice.opened</span>
            </div>

            <div *ngIf="isPartialPaid(invoice)">
              <span class="badge badge-pill badge-warning px-3 py-2" translate><i class="fa fa-dollar-sign mr-2"></i>Partial</span>
            </div>

          </div>
        </div>
        
        <div class="mt-auto payment">
          <div class="d-flex justify-content-between">
            <p translate>invoice.creditsCost</p>
            <span class="ml-1">{{invoice.amount}}</span>
          </div>
          <div *ngIf="currentUser.role.name !== 'user' && invoice.type === 'postpaid'" class="d-flex justify-content-between">
            <p translate>invoice.creditsFromAccount</p>
            <span class="ml-1">{{invoice.credits}}</span>
          </div>
          <div *ngIf="invoice.type === 'postpaid' && isPartialPaid(invoice)" class="d-flex justify-content-between">
            <p translate>invoice.creditsPaid</p>
            <span class="ml-1">{{invoice.paidAmount}}</span>
          </div>
          <hr *ngIf="invoice.type === 'postpaid'">
          <div *ngIf="invoice.type === 'postpaid'" style="font-weight: bold;">
            <div class="d-flex justify-content-between" *ngIf="!invoice.closed">
              <p translate>invoice.totalToPay</p>
              <span class="ml-1">{{invoice.amount - invoice.credits - +invoice.paidAmount}}</span>
            </div>
            <div class="d-flex justify-content-between" *ngIf="invoice.closed">
              <p translate>invoice.paid</p>
              <span class="ml-1">{{+invoice.paidAmount}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="invoices && invoices.results.length" class="d-flex justify-content-end mt-3">
    <ngb-pagination [collectionSize]="invoices.count" [(pageSize)]="perPage" [(page)]="page" [maxSize]="5"
      [rotate]="true" (pageChange)="jumpToPage($event)"></ngb-pagination>
  </div>
</div>

<app-modal (close)="togglePay = !togglePay" *ngIf="togglePay">
  <div class="modal_container black-text">
    <div class="modal-header">
      <h4 class="modal-title" translate>crop.areYouSure</h4>
    </div>
    <div class="modal-body">
     <div class="d-flex justify-content-between">
       <form class="d-flex" *ngIf="invoice.type === 'postpaid'" #payInvoiceForm="ngForm">
         <div>
           <input type="text" name="amount" ngModel class="form-control" [attr.placeholder]="'invoice.amountToPay' | translate">
         </div>
         <button #button style="min-width: 80px;" *ngIf="invoice.type === 'postpaid'" class="custom-button ml-2" (click)="payInvoice(payInvoiceForm)" translate>invoice.pay</button>
      </form>
      <div>
        <button *ngIf="invoice.type !== 'postpaid'" class="custom-button mr-2" (click)="closeInvoice()" translate>invoice.close</button>
        <button class="custom-button" (click)="togglePay = false;" translate>global.cancel</button>
      </div>
     </div>
    </div>
  </div>
</app-modal>

<app-modal (close)="toggleAddInvoice = !toggleAddInvoice" *ngIf="toggleAddInvoice">
  <div class="modal_container black-text">
    <div class="modal-header">
      <h4 *ngIf="showMessage" class="modal-title" translate>This client already has an open invoice. Do you want to create new one ?</h4>
    </div>
    <div class="modal-body">
     <div class="d-flex justify-content-end">
       <button class="custom-button mr-2" (click)="newInvoice()">Create</button>
       <button class="custom-button" (click)="toggleAddInvoice = false;">Cancel</button>
     </div>
    </div>
  </div>
</app-modal>
